import { Button, Checkbox, ConfirmModal, DropDown, Input } from "@src/components";
import { Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import {
    nonPaymentOfPenaltyListRequestType,
    useGetNonPaymentOfPenaltyList,
    useNonPaymentOfPenaltyProcessingCompleted,
} from "@src/hooks/queries/usePaymentList";

import { Common } from "@src/styles/Common";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

const initPagination: nonPaymentOfPenaltyListRequestType = {
    page: 1,
    limit: 30,
    searchText: null,
    category: 0,
    status: null,
};

const PaymentCancel = () => {
    const navigate = useNavigate();

    const [checkbox, setCheckbox] = useState({
        processing: false,
        unProcessing: false,
    });
    const [requestParams, setRequestParams] = useState(initPagination);
    const [isOpenConfirmModal, setIsOpenConfirmModal] = useState<{
        status: boolean;
        name: string;
        failedPayNo: number;
    }>({
        status: false,
        name: "",
        failedPayNo: 0,
    });

    const { data: nonPaymentOfPenaltyList, refetch: nonPaymentOfPenaltyListRefetch } = useGetNonPaymentOfPenaltyList(
        requestParams,
        true,
    );
    const { mutate: nonPaymentOfPenaltyProcessingCompleted } = useNonPaymentOfPenaltyProcessingCompleted();

    const handleSearch = () => {
        console.log(requestParams.searchText !== null && requestParams.category === null);
        if (requestParams.searchText !== null && requestParams.category === null) {
            setRequestParams({
                ...requestParams,
                category: 0,
            });
            nonPaymentOfPenaltyListRefetch();
        } else {
            nonPaymentOfPenaltyListRefetch();
        }
    };

    return (
        <Layout>
            {isOpenConfirmModal.status && (
                <ConfirmModal
                    buttonText="확인"
                    handleCancel={() => {
                        setIsOpenConfirmModal({ status: false, name: "", failedPayNo: 0 });
                    }}
                    handleOk={() => {
                        nonPaymentOfPenaltyProcessingCompleted(isOpenConfirmModal.failedPayNo, {
                            onSuccess: () => {
                                nonPaymentOfPenaltyListRefetch();
                                setIsOpenConfirmModal({ status: false, name: "", failedPayNo: 0 });
                            },
                        });
                    }}
                    isModalShow={isOpenConfirmModal.status}
                >
                    <div className="ConfrimModalBox">
                        <div className="Title">처리완료</div>
                        <div className="SubTitle">
                            {isOpenConfirmModal.name}님의 위약금 미결제를 <br /> 처리 완료하시겠습니까?
                        </div>
                    </div>
                </ConfirmModal>
            )}

            <TopContent>
                <div className="Title">위약금 미결제 관리</div>

                <div className="FilterBox">
                    <div className="FilterStatusBox">
                        <div className="text" style={{ width: "72px" }}>
                            상태
                        </div>
                        <div className="text" style={{ width: "90px" }}>
                            <Checkbox
                                isDisabled={false}
                                isChecked={checkbox.unProcessing}
                                label={"미처리"}
                                handleChange={(n, v) => {
                                    setCheckbox({
                                        unProcessing: true,
                                        processing: false,
                                    });
                                    setRequestParams({
                                        ...requestParams,
                                        status: v ? 0 : null,
                                    });
                                }}
                            />
                        </div>
                        <div className="text" style={{ width: "90px" }}>
                            <Checkbox
                                isDisabled={false}
                                isChecked={checkbox.processing}
                                label={"처리완료"}
                                handleChange={(n, v) => {
                                    setCheckbox({
                                        unProcessing: false,
                                        processing: true,
                                    });
                                    setRequestParams({
                                        ...requestParams,
                                        status: v ? 200 : null,
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="FilterStatusBox">
                        <div className="text" style={{ width: "72px" }}>
                            검색
                        </div>
                        <div className="text">
                            <DropDown
                                handleChange={(e) => {
                                    setRequestParams({
                                        ...requestParams,
                                        category: Number(e.target.value),
                                    });
                                }}
                                data={[
                                    {
                                        id: 0,
                                        key: "0",
                                        value: "이름",
                                    },
                                    {
                                        id: 1,
                                        key: "1",
                                        value: "이메일",
                                    },
                                    {
                                        id: 2,
                                        key: "2",
                                        value: "미결제 금액",
                                    },
                                ]}
                                defaultValue={"이름"}
                            />
                        </div>
                        <div className="text">
                            <Input
                                label=""
                                value={requestParams.searchText ?? ""}
                                name="searchInput"
                                type="text"
                                size="medium"
                                handleChange={(e) => {
                                    setRequestParams({
                                        ...requestParams,
                                        searchText: e.target.value,
                                    });
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSearch();
                                    }
                                }}
                                isDisabled={false}
                                errorMessage=""
                                placeholder="이름이나 연락처, 승인번호를 입력하세요."
                            />
                        </div>
                    </div>
                </div>

                <div className="ButtonBox">
                    <Button
                        color="gray"
                        handleClick={() => {
                            setRequestParams(initPagination);
                            nonPaymentOfPenaltyListRefetch();
                        }}
                        label="전체 해제"
                        size="medium"
                    />
                    <Button color="purple" handleClick={() => handleSearch()} label="검색" size="medium" />
                </div>
            </TopContent>

            <ListContent>
                <div className="StatusText">
                    <div>누적 {nonPaymentOfPenaltyList?.total?.toLocaleString()}건</div>
                    <div>|</div>
                    <div>이번달 {nonPaymentOfPenaltyList?.monthly?.toLocaleString()}건</div>
                </div>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 960 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">결제번호</TableCell>
                                <TableCell align="center">이름</TableCell>
                                <TableCell align="center">이메일</TableCell>
                                <TableCell align="center">탈퇴일</TableCell>
                                <TableCell align="center">결제수단</TableCell>
                                <TableCell align="center">미결제금액</TableCell>
                                <TableCell align="center">미결제 사유</TableCell>
                                <TableCell align="center">상품명</TableCell>
                                <TableCell align="center">상태</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {nonPaymentOfPenaltyList?.list.map((item: any) => (
                                <TableRow key={item?.no} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                    <TableCell align="center" component="th" scope="row">
                                        {item?.no}
                                    </TableCell>
                                    <TableCell align="center">{item?.userName}</TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{ cursor: "pointer", color: "#1890ff", textDecoration: "underline" }}
                                        onClick={() => {
                                            navigate(`/users/detail/${item?.userNo}`);
                                        }}
                                    >
                                        {item?.userId}
                                    </TableCell>
                                    <TableCell align="center">
                                        {item?.leaveDate.split("T")[0]}
                                        <br />
                                        {item?.leaveDate.split("T")[1].split(".")[0]}
                                    </TableCell>
                                    <TableCell align="center">
                                        {item?.cardName ? `${item?.cardName}(${item?.cardNumberLast4})` : `위젯페이`}
                                    </TableCell>
                                    <TableCell align="center">{item?.notPaidAmount?.toLocaleString()}원</TableCell>
                                    <TableCell align="center">{item?.reason}</TableCell>
                                    <TableCell align="center">{item?.productName}</TableCell>
                                    <TableCell align="center" className={item?.failedPayStatus === 0 ? "미처리" : ""}>
                                        {item?.failedPayStatus === 0 ? "미처리" : "처리완료"}
                                        {item?.failedPayStatus === 0 ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                <Button
                                                    color="purple"
                                                    handleClick={() => {
                                                        setIsOpenConfirmModal({
                                                            status: true,
                                                            name: item?.userName,
                                                            failedPayNo: item?.no,
                                                        });
                                                    }}
                                                    label="처리완료"
                                                    size="small"
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                {item?.paidDate ? item?.paidDate.split("T")[0] : ""}
                                                <br />
                                                {item?.paidDate ? item?.paidDate.split("T")[1].split(".")[0] : ""}
                                            </div>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <div style={{ marginTop: "20px", width: "100%", display: "flex", justifyContent: "center" }}>
                    <Pagination
                        count={Math.ceil(nonPaymentOfPenaltyList?.total / requestParams.limit)}
                        page={requestParams.page}
                        onChange={(e, page) => {
                            setRequestParams({ ...requestParams, page });
                        }}
                        shape="rounded"
                    />
                </div>
            </ListContent>
        </Layout>
    );
};

const Layout = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 63px 95px 0 95px;

    .미처리 {
        color: #f00;
        font-size: 13px;
        font-weight: 400;
        line-height: 160%;
    }

    .ConfrimModal--Style {
        min-width: 312px !important;
    }

    .ConfrimModalBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        gap: 14px;

        .Title {
            color: #0c002c;
            text-align: center;
            font-size: 20px;
            font-weight: 800;
            line-height: 26px;
        }

        .SubTitle {
            color: #0c002c;
            text-align: center;
            font-size: 18px;
            font-weight: 500;
            line-height: 24px;
        }
    }

    input[name="searchInput"] {
        margin-left: 12px;
        height: 36px;
        border: 1px solid ${Common.colors.gray200};
        border-radius: 8px;
        &::placeholder {
            color: ${Common.colors.gray500};
        }
    }
`;

const TopContent = styled.div`
    .Title {
        width: 1500px;
        height: 40px;
        display: flex;
        align-items: center;

        color: #222;
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
    }

    .FilterBox {
        width: 1500px;
        height: 209px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 12px;
        padding: 16px 60px;

        border-radius: 8px;
        background: #f4f5f7;

        .text {
            display: flex;
            flex-direction: row;
            align-items: center;

            color: #222;
            font-size: 15px;
            font-weight: 400;
            line-height: 140%;
            letter-spacing: -0.4px;
        }

        .FilterStatusBox {
            display: flex;
            flex-direction: row;
            align-content: center;
        }
    }

    .ButtonBox {
        width: 1500px;
        display: flex;
        flex-direction: row;
        justify-content: end;
        gap: 17px;
        margin-top: 23px;
        margin-bottom: 100px;
    }
`;

const ListContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 21px;

    color: #222;
    font-size: 13px;
    font-weight: 400;
    line-height: 160%;

    .StatusText {
        display: flex;
        flex-direction: row;
        gap: 12px;
    }
`;

export default PaymentCancel;
